import { DriveEta } from '@mui/icons-material';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import DirectionsIcon from '@mui/icons-material/Directions';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import PhoneIcon from '@mui/icons-material/Phone';
import { CardActionArea, Tooltip } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import React from 'react';
import Colors from '../../colors';
import SelectableCardContentRow from '../SelectableCardContentRow';

function LocationAccordian({ location, isAdmin, setIsVisible, setSelectedLocation }) {
  const govtStyle = { width: '33px', height: '38px', color: 'purple', marginRight: '20px' }
  const siteStyle = { width: '33px', height: '38px', color: Colors.green, marginRight: '20px' }
  const hospitalStyle = { width: '33px', height: '38px', color: Colors.red, marginRight: '20px' }
  const rescueStyle = { width: '33px', height: '38px', marginRight: '20px' }
  const accordionStyle = {
    borderRadius: '20px',
    border: `1px solid ${Colors.blue}`,
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
    width: '500px',
    maxWidth: '100%',
  }

  const accordionSummaryStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }

  const nameStyle = {
    margin: 'auto',
    paddingRight: 10,
    fontWeight: '400',
    fontSize: '19px'
  }
  const StyledEditIcon = styled(BorderColorIcon)({
    width: '1.6rem',
    height: '1.9rem',
    margin: '5px',
    marginLeft: '91%',
    color: Colors.mediumGray

  });

  const addressClickHandler = (e, address) => {
    e.stopPropagation();
    const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
    window.open(mapsUrl, '_blank');
  };

  function extractPhoneNumber(phoneNumber) {
    const cleanedNumber = phoneNumber.replace(/[()-]/g, '');
    const extractedNumber = cleanedNumber.replace(/\D/g, '');
    return extractedNumber;
  }

  const makeCall = (e, number) => {
    e.stopPropagation();
    const phoneNumberValue = (number || '').trim();
    if (extractPhoneNumber(phoneNumberValue) === '911' || phoneNumberValue) {
      window.open(`tel:${phoneNumberValue}`, '_self');
    } else {
      window.alert("Please enter a valid number");
    }
  }

  const handleEditClick = () => {
    if (!isAdmin) return;
    setSelectedLocation(location)
    setIsVisible(true)
  }

  const getHospitalMainText = () => {
    if (location?.nearestHospital?.eta) return <>{location?.nearestHospital?.name}&nbsp;&nbsp;<DriveEta sx={{ marginBottom: '-6px' }} />{location?.nearestHospital?.eta}min</>
    else return location?.nearestHospital?.name
  }

  return (
    <div style={{ maxWidth: '100%' }}>
      <Accordion style={accordionStyle}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} style={accordionSummaryStyles}>
          <Tooltip title="Get Directions" >
            <DirectionsIcon style={{ color: Colors.blue, width: '38px', height: '38px' }} onClick={(e) => addressClickHandler(e, location.locationName)} />
          </Tooltip>
          <span style={nameStyle}>{location.locationName}</span>
        </AccordionSummary>
        <Divider />
        <AccordionDetails onClick={handleEditClick} style={{ padding: 0 }}>
          <CardActionArea sx={{ padding: '8px 16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <SelectableCardContentRow iconComponent={<LocalHospitalIcon style={hospitalStyle} />} title={"Nearest Hospital"} mainText={getHospitalMainText()} subText={location?.nearestHospital?.address}></SelectableCardContentRow>
              <Tooltip title="Get Directions" >
                <DirectionsIcon sx={{ fontSize: 42 }} style={{ color: Colors.blue, marginLeft: '1px', cursor: 'pointer' }} onClick={(e) => addressClickHandler(e, location?.nearestHospital?.address)} />
              </Tooltip>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <SelectableCardContentRow iconComponent={<AirplanemodeActiveIcon style={rescueStyle} />} title={'Search And Rescue'} mainText={location?.searchAndRescue?.name} subText={location?.searchAndRescue?.phone}></SelectableCardContentRow>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '48px' }}>
                <Tooltip title="Call Search and Rescue" >
                  <PhoneIcon onClick={(e) => makeCall(e, location?.searchAndRescue?.phone)} sx={{ fontSize: 32, color: Colors.blue, marginLeft: '1px', cursor: 'pointer' }} />
                </Tooltip>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <SelectableCardContentRow iconComponent={<ContactEmergencyIcon style={govtStyle} />} title={'Local Government Contact'} mainText={location?.localGovContact?.name} subText={location?.localGovContact?.phone}></SelectableCardContentRow>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '48px' }}>
                <Tooltip title="Call Local Gov Contact" >
                  <PhoneIcon onClick={(e) => makeCall(e, location?.localGovContact?.phone)} sx={{ fontSize: 32, color: Colors.blue, marginLeft: '1px', cursor: 'pointer' }} />
                </Tooltip>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <SelectableCardContentRow iconComponent={<ContactEmergencyIcon style={siteStyle} />} title={'Site Contact'} mainText={location?.siteContact?.name} subText={location?.siteContact?.phone}></SelectableCardContentRow>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '48px' }}>
                <Tooltip title="Call Site Contact" >
                  <PhoneIcon onClick={(e) => makeCall(e, location?.siteContact?.phone)} sx={{ fontSize: 32, color: Colors.blue, marginLeft: '1px', cursor: 'pointer' }} />
                </Tooltip>
              </div>
            </div>
            {isAdmin && <StyledEditIcon onClick={handleEditClick} />}
          </CardActionArea>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default LocationAccordian